<ng-container [ngSwitch]="reservationStatus">
  <span *ngSwitchCase="ReservationStatus.Arrived" i18n="Arrival">Arrival</span>
  <span *ngSwitchCase="ReservationStatus.UnloadingStarted" i18n="Unloading start">Unloading start</span>
  <span *ngSwitchCase="ReservationStatus.UnloadingDone" i18n="Unloading end">Unloading done</span>
  <span *ngSwitchCase="ReservationStatus.Departed" i18n="Departure">Departure</span>
  <span *ngSwitchCase="ReservationStatus.AwaitingArrival" i18n="Awaiting arrival">Awaiting arrival</span>
</ng-container>
